import React from 'react'


export default function NewArrival() {
  return (
    <>
     
<section id="NewArrivals">
    <h2>New Arrival</h2>
    <p>Summer Collection New Modern Design</p>

    <div className="pro_Container" data-aos="flip-left"
        data-aos-easing="ease-out-cubic"
        data-aos-duration="2000"> 

        <div className="pro" data-aos="fade-left" data-aos-offset="100" data-aos-delay="100">
            <img src="images/New Arrival/NewArrival1.jpg" alt="" />
            <div className="des">
                <span>Adidas</span>
                <h5>Cartoon Astronaut Shirt</h5>
                <div className="star">
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                </div>
<h4>$43</h4>
            </div>
            <i className="fa fa-shopping-cart carts" aria-hidden="true"></i>

        </div>



        <div className="pro" data-aos="fade-right" data-aos-offset="100" data-aos-delay="300" >
            <img src="images/New Arrival/NewArrival2.jpg" alt="" />
            <div className="des">
                <span>Adidas</span>
                <h5>Cartoon Astronaut Shirt</h5>
                <div className="star">
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                </div>
<h4>$43</h4>
            </div>
            <i className="fa-sharp fa-solid fa-cart-shopping carts"></i>

        </div>



        <div className="pro" data-aos="fade-left" data-aos-offset="100" data-aos-delay="100">
            <img src="images/New Arrival/NewArrival3.jpg" alt="" />
            <div className="des">
                <span>Adidas</span>
                <h5>Cartoon Astronaut Shirt</h5>
                <div className="star">
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                </div>
<h4>$43</h4>
            </div>
            <i className="fa-sharp fa-solid fa-cart-shopping carts"></i>

        </div>



        <div className="pro" data-aos="fade-right" data-aos-offset="100" data-aos-delay="300" >
            <img src="images/New Arrival/NewArrival4.jpg" alt=""/>
            <div className="des">
                <span>Adidas</span>
                <h5>Cartoon Astronaut Shirt</h5>
                <div className="star">
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                </div>
<h4>$43</h4>
            </div>
            <i className="fa-sharp fa-solid fa-cart-shopping carts"></i>

        </div>




        <div className="pro" data-aos="fade-left" data-aos-offset="100" data-aos-delay="100">
            <img src="images/New Arrival/NewArrival5.jpg" alt=""/>
            <div className="des">
                <span>Adidas</span>
                <h5>Cartoon Astronaut Shirt</h5>
                <div className="star">
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                </div>
<h4>$65</h4>
            </div>
            <i className="fa-sharp fa-solid fa-cart-shopping carts"></i>

        </div>




        <div className="pro" data-aos="fade-right" data-aos-offset="100" data-aos-delay="300" >
            <img src="images/New Arrival/NewArrival6.jpg" alt="" />
            <div className="des">
                <span>Adidas</span>
                <h5>Cartoon Astronaut Shirt</h5>
                <div className="star">
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                </div>
<h4>$43</h4>
            </div>
            <button><i className="fa-sharp fa-solid fa-cart-shopping carts"></i></button>

        </div>



        <div className="pro" data-aos="fade-left" data-aos-offset="100" data-aos-delay="100">
            <img src="images/New Arrival/NewArrival7.jpg" alt=""/>
            <div className="des">
                <span>Adidas</span>
                <h5>Cartoon Astronaut Shirt</h5>
                <div className="star">
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                </div>
<h4>$43</h4>
            </div>
            <i className="fa-sharp fa-solid fa-cart-shopping carts" id="cart"></i>

        </div>



        <div className="pro" data-aos="fade-right" data-aos-offset="100" data-aos-delay="300" >
            <img src="images/New Arrival/NewArrival8.jpg" alt="" />
            <div className="des">
                <span>Adidas</span>
                <h5>Cartoon Astronaut Shirt</h5>
                <div className="star">
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                       <i className="fas fa-star"></i>
                </div>
<h4>$43</h4>
            </div>
            <i className="Carts fa fa-shopping-cart carts" aria-hidden="true"></i>

        </div>

    </div>

</section>
 
    </>
  )
}
